<template>
  <div class="informativa" :style="{ height: (contenitoreHeight)+ 'px'}">
    <div class="col-24 info-title">
      <span>{{ $i18n.t('info.title') }}</span>
    </div>
    <div class="info-body">
      <div class="col-24 no-padding data">
          {{ $t('info')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import mixinDownload from "../../assets/mixins/downloadDoc.js";

  export default {
    components: {},
    name: 'Informativa',
    mixins: [mixinDownload],
    props: ['contenitoreHeight'],
    i18n: {
      messages: {
        it_IT: {
          info: {
            title: 'Informativa',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica'
          }
        },
        fr_FR: {
          info: {
            title: 'Informativa',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche'
          }
        },
        es_ES: {
          info: {
            title: 'Informativa',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo'
          }
        },
        de_DE: {
          info: {
            title: 'Informativa',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag'
          }
        },
        en_GB: {
          info: {
            title: 'Informativa',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loading: false,
        messaggio: {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
      }
    },
    computed: {
      homeStyle: function () {
        let path = this.$route.path
        return (path.indexOf('/app/informativa') !== 0)
      }
    },
    activated: function () {
      this.loadInformativa()
    },
    deactivated: function () {
      this.resetDati()
    },
    mounted: function () {
      this.loadInformativa()
    },
    methods: {
      resetDati: function () {
        this.$set(this, 'loading', true)
        let msg = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        this.$set(this, 'informativa', msg)
      },
      loadInformativa: function () {
        this.$set(this, 'loading', true)
        let msg = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        this.$set(this, 'informativa', msg)
        var obj = {
          params: {
            seBlock: 'N',
            tipo: 'INF',
            order: '',
            mesi: '999'
          }
        }
        this.$http.get('communication/' + this.$store.state.country + '/messaggi', obj).then(response => {
          if (response.body.rc === 0 && response.body.data.length === 1) {
            this.$set(this, 'messaggio', response.body.data[0])
            this.$set(this, 'loading', false)
          } else {
            this.$set(this, 'loading', false)
          }
        }, response => {
          this.$set(this, 'loading', false)
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .informativa {
    height: 100%;
    padding-bottom: 10px;
    overflow: auto;
    .info-title {
      padding-left: 10px;
      padding-right: 10px;
      width: 100%;
      height: 40px;
      text-align: center;
      margin-bottom: 20px;
      span {
        line-height: 40px;
        height: 40px;
        text-align: center;
        width: calc(100% - 50px);
        .set-font(@color: @rossoRiva, @size: 20px, @family: 'os-regular');
        font-weight: bold;
        letter-spacing: 2px;
        text-transform: uppercase;
        height: 40px;
        letter-spacing: 2px;
        padding-top: 10px;
      }
      /*span {
        display: block;
        text-align: left;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family:'os-regular');
      }*/
    }
    .info-body {
      padding-left: 10px;
      padding-right: 10px;
      overflow: auto;
      height: calc(100% - 65px);
      .data {
          width: 100%;
          text-align: right;
          margin-top: 10px;
          .set-font(@size: 12px, @color: @textTable);
          font-style: italic;
          padding: 0 4px !important;
        }
        .priorita {
          margin-top: 15px;
          text-align: left;
          .prior-label {
            .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
          }
          .prior-value {
            margin-left: 2px;
            .set-font(@color: red, @size: 14px, @family: 'os-semibold');
          }
          .prior-icon {
            .fa-icon {
              color: red;
              margin-top: -4px;
              margin-left: 2px;
            }
          }
        }
        .testo {
          margin-top: 20px;
          .set-font(@color: @textTable, @size: 13px);
          text-align: justify;
          height: auto;
          overflow: auto;
          padding-right: 5px !important;
          word-break: break-word;
        }
        .allegati {
          min-height: 30px;
          max-height: 120px;
          overflow: auto;
          margin-top: 30px;
          margin-bottom: 20px;
          .allegato {
            display: inline-block;
            .icona {
              width: 10%;
              float: left;
              padding-top: 2px;
            }
            .titolo-allegato {
              width: 85%;
              float: left;
              .set-font(@color: @greenRiva, @size: 13px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .allegato:hover {
            cursor: pointer;
          }
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Informativa.vue